import React, {Component} from "react";
import Container from "react-bootstrap/Container";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Execution from '../Execution/Execution';
//import PaginationWidget from "../UI/PaginationWidget/PaginationWidget";
import classes from './ExecutionsList.module.css';
import axios from "axios";
import apiUrl from "../../shared/config";
import AnchorLink from "react-anchor-link-smooth-scroll";

class ExecutionsList extends Component {

    state = {
        count: 0,
        authenticated: false,
        patternExecutions: []
    };

    componentDidMount() {
        //console.log("In Executions mount. Exercise Id: " + this.props.exerciseId);
        // const url = apiUrl +'Exercises/getExerciseExecutions';
        // //const quantity = (this.props.isAuthenticated ? this.props.gameList.quantity : this.props.gameList.quantity + 1);
        // const params = {
        //     params: {
        //         //quantity: quantity,
        //         //offset: this.props.gameList.offset,
        //         exercise_id: this.props.exerciseId,
        //         token: this.props.token
        //         //game_name_filter: this.props.gameNameFilter,
        //         //game_description_filter: this.props.gameDescriptionFilter,
        //         //game_type_ids_array: this.props.gameTypesFilter,
        //         //game_publisher_ids_array: this.props.gamePublishersFilter,
        //         //game_developer_ids_array: this.props.gameDevelopersFilter,
        //         //game_style_id: this.props.gameStyleFilter,
        //         //start_date: this.props.releaseStartFilter,
        //         //end_date: this.props.releaseEndFilter,
        //         //keyword_ids_array: this.props.keywordsFilter,
        //         //author: this.props.authorFilter,
        //         //order_by: this.props.order_by,
        //     }
        // };
        // axios.get(url, params)
        //     .then(response => {
        //         this.setState({patternExecutions: response.data.executions_array});
        //         //this.setState({count: response.data.game_count});
        //         //this.props.updateCount(response.data.game_count);
        //         //this.setState({authenticated: this.props.isAuthenticated});
        //     }).then(
        //     this.props.executionsListReloaded()
        // );


    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        //console.log("In Executions update. Exercise Id: " + this.props.exerciseId);
        //console.log("In Executions update. Reload Executions List: " + this.props.reloadExecutionsList);
        if(
            this.props.reloadExecutionsList === true //||
            //prevProps.gameList.offset !== this.props.gameList.offset ||
            //prevProps.order_by !== this.props.order_by ||
            //this.props.isAuthenticated !== this.state.authenticated
        ) {
            const url = apiUrl +'Exercises/getExerciseExecutions';
            //this.setState({authenticated: this.props.isAuthenticated});
            //const quantity = (this.props.isAuthenticated ? this.props.gameList.quantity : this.props.gameList.quantity + 1);
            const params = {
                params: {
                    exercise_id: this.props.exerciseId,
                    token: this.props.token
                    //quantity: quantity,
                    //offset: this.props.gameList.offset,
                    //game_name_filter: this.props.gameNameFilter,
                    //game_description_filter: this.props.gameDescriptionFilter,
                    //game_type_ids_array: this.props.gameTypesFilter,
                    //game_publisher_ids_array: this.props.gamePublishersFilter,
                    //game_developer_ids_array: this.props.gameDevelopersFilter,
                    //game_style_id: this.props.gameStyleFilter,
                    //start_date: this.props.releaseStartFilter,
                    //end_date: this.props.releaseEndFilter,
                    //keyword_ids_array: this.props.keywordsFilter,
                    //author: this.props.authorFilter,
                    //order_by: this.props.order_by,
                }
            };
            axios.get(url, params)
                .then(response => {
                    this.setState({patternExecutions: response.data.executions_array});
                    //this.setState({count: response.data.game_count});
                    //this.props.updateCount(response.data.game_count);
                })
                .then(
                    this.props.executionsListReloaded()
                );
        }
    }

    render() {
        // let newGameSlug = (
        //     <Col className={classes.GameListCol} key="0">
        //         <Game
        //             selected="NewGameList"
        //             key="0"
        //             name="Add New Game"
        //             description="Open the New Game panel to add a game."
        //             clicked={() => {
        //                 this.props.newGame(null);
        //                 this.props.closeGameDetails();
        //                 this.props.gameSelected(null);
        //             }}
        //         />
        //     </Col>
        // );
        // newGameSlug = (this.props.isAuthenticated ? newGameSlug : '');
        //const quantity = (this.
        // props.isAuthenticated ? this.props.gameList.quantity : this.props.gameList.quantity + 1);
        let executions = [];
        // only show the executions nav if there are more than one execution, or if the exercise ID is more than 45
        // in which case the execution wouldn't load by default and the nav will be necessary to select it.
        // TLDR only hide the nav if looking at an exercise from the book with no other executions.
        if (
            this.state.patternExecutions.length > 1 ||
            (this.state.patternExecutions.length > 0 && this.state.patternExecutions[0].exercise_id > 45)
        ) {
            executions = this.state.patternExecutions.map(execution => {
                let isSelected = '';
                if (this.props.selectedExecutionId === execution.execution_id) {
                    isSelected = ' selected';
                }
                let usersString = '';
                let separator = '';
                const authors = execution.users.map(user => {
                    if (usersString !== '') {
                        separator = ', ';
                    }
                    usersString += user.display_name;
                    return separator + user.display_name;
                })
                return (
                    <Col className={classes.ExecutionListCol} key={execution.execution_id}>
                        <AnchorLink className="no-link-style" offset='80' href='#exercise-details'>
                            <Execution
                                selected={isSelected}
                                key={execution.execution_id}
                                name={execution.exercise_name}
                                seed={execution.seed}
                                date={execution.created + ' '}
                                authors={authors}
                                clicked={
                                    () => {
                                        this.props.exerciseSelected(execution.exercise_id)
                                        this.props.executionSelected(execution.exercise_id, execution.execution_id)
                                    }
                                }
                            />
                        </AnchorLink>
                    </Col>
                )
            });

            return (
                <div className={"d-flex " + classes.ExecutionsListWrapper}>
                    <div className={classes.ExecutionsList}>
                        <Container fluid className={classes.ExecutionsListContainer}>
                            <Row xs={1} md={2} lg={2} xl={3}>
                                {executions}
                            </Row>
                        </Container>
                    </div>
                </div>
            );
        }
        else {
            return null;
        }
    }
}



export default ExecutionsList;